export default function PreviewBookingSection({ config }) {
  const theme = config?.theme || {};
  const primary = theme.primary || "#9df03d";
  const onPrimary = theme.onPrimary || "#05070a";

  return (
    <section style={{ padding: "0 24px 24px" }}>
      <div
        style={{
          borderRadius: "var(--ns-radius-xl)",
          background: "var(--ns-card)",
          border: "1px solid var(--ns-card-border)",
          boxShadow: "var(--ns-shadow)",
          overflow: "hidden"
        }}
      >
        <div style={{ padding: "18px 18px 10px" }}>
          <div style={{ display: "flex", alignItems: "baseline", gap: 10 }}>
            <h2 style={{ margin: 0, color: "var(--ns-ink)", fontWeight: 950, fontSize: 22 }}>
              Reserve a Table
            </h2>
            <span style={{ width: 8, height: 8, borderRadius: 999, background: primary, display: "inline-block" }} />
          </div>
          <p style={{ margin: "8px 0 0", color: "var(--ns-muted)", fontSize: 13 }}>
            Available time slots will appear here after search.
          </p>
        </div>

        <div
          style={{
            padding: 18,
            display: "grid",
            gap: 12,
            borderTop: "1px solid rgba(15,23,42,0.06)",
            background:
              "radial-gradient(700px 240px at 10% 0%, rgba(157,240,61,0.16), transparent 55%)," +
              "linear-gradient(180deg, rgba(255,255,255,0.60), rgba(255,255,255,0.92))"
          }}
        >
          <div
            style={{
              borderRadius: 18,
              border: "1px solid rgba(15,23,42,0.10)",
              background: "rgba(255,255,255,0.75)",
              padding: 16
            }}
          >
            <div style={{ fontWeight: 800, color: "var(--ns-ink)" }}>Booking form preview</div>
            <div style={{ marginTop: 10, display: "flex", gap: 10, flexWrap: "wrap" }}>
              <Pill label="Date" value="Jan 01, 2026" />
              <Pill label="Time" value="7:30 PM" />
              <Pill label="Guests" value="2" />
            </div>

            <button
              type="button"
              style={{
                marginTop: 14,
                border: "none",
                borderRadius: 999,
                padding: "12px 16px",
                fontWeight: 950,
                cursor: "pointer",
                background: `linear-gradient(180deg, ${primary}, rgba(0,0,0,0.10))`,
                color: onPrimary,
                boxShadow: "0 14px 30px rgba(15,23,42,0.14)"
              }}
            >
              Check Availability
            </button>
          </div>

          <div style={{ color: "rgba(17,24,39,0.55)", fontSize: 12 }}>
            This is a preview-only layout. Public engine will use your live availability.
          </div>
        </div>
      </div>
    </section>
  );
}

function Pill({ label, value }) {
  return (
    <div
      style={{
        display: "flex",
        gap: 8,
        alignItems: "center",
        borderRadius: 999,
        padding: "9px 12px",
        border: "1px solid rgba(15,23,42,0.10)",
        background: "rgba(255,255,255,0.85)"
      }}
    >
      <span style={{ fontSize: 12, color: "rgba(17,24,39,0.55)", fontWeight: 800 }}>
        {label}
      </span>
      <span style={{ fontSize: 12, color: "#0b1220", fontWeight: 950 }}>
        {value}
      </span>
    </div>
  );
}
